import produce from 'immer';
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  SILENT_LOGIN,
  UPDATE_PROFILE
} from 'src/actions/accountActions';

const initialState = {
  user: null,
  isAdmin: false
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST: {
      return produce(state, (draft) => {
        // Ensure we clear current session
        draft.user = null;
      });
    }

    case LOGIN_SUCCESS: {
      const { user } = action.payload;

      return produce(state, (draft) => {
        draft.user = user;
        draft.isAdmin = user.role === 'Admin';
      });
    }

    case LOGIN_FAILURE: {
      return produce(state, () => {
        // Maybe store error
      });
    }

    case LOGOUT: {
      return produce(state, (draft) => {
        draft.user = null;
      });
    }

    case SILENT_LOGIN: {
      const { user } = action.payload;

      return produce(state, (draft) => {
        draft.user = user;
        draft.isAdmin = user.role === 'Admin';
      });
    }

    case UPDATE_PROFILE: {
      const user = action.payload;
      localStorage.setItem('loggedInUser', JSON.stringify(user));

      return produce(state, (draft) => {
        draft.user = user;
        draft.isAdmin = user.role === 'Admin';
      });
    }

    default: {
      return state;
    }
  }
};

export default accountReducer;
